import { IBoMonActionTypes } from "../../action-types/category/IBoMonActions";
import { IBoMonReducer } from "../../reducer-model/category/IBoMonReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const initState: IBoMonReducer = {
  status: eReducerStatusBase.is_not_initialization,
  boMons: [],
  filter: {
    id_khoa: 0,
  },
  selectedIds: []
};
export const boMonReducer = (
  state: IBoMonReducer = initState,
  action: IBoMonActionTypes
): IBoMonReducer => {
  switch (action.type) {
    case "BO_MON_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "BO_MON_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        boMons: action.payload,
      };
    case "BO_MON_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "BO_MON_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        boMonEditing: action.payload,
      };
    case "BO_MON_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "BO_MON_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "BO_MON_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "BO_MON_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "BO_MON_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "BO_MON_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "BO_MON_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "BO_MON_CHANGE_FILTER":
      return {
        ...state,
        filter: action.payload,
      };
    case "BO_MON_CHANGE_SELECTED_IDS":
      return {
        ...state,
        selectedIds: action.payload,
      };
    default:
      return state;
  }
};
